<style scoped>
.checkin_information_data_statistics_all {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.checkin_information_data_statistics {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 40px;
  margin: 14px 0 10px 0;
}
.checkin_information_data_statistics_sing {
  display: flex;
  align-items: center;
}
.checkin_information_data_statistics_title {
  color: rgba(19, 21, 35, 0.65);
  font-size: 16px;
}
.checkin_information_data_statistics_people {
  font-size: 30px;
  font-weight: bold;
  color: #131523;
  margin-left: 5px;
}
::v-deep .el-input__icon {
  line-height: 1.5rem;
}
.checkin_information_attendance_text {
  width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.checkin_information_data_content {
  width: 100%;
  padding: 0 0px 0 0px;
  box-sizing: border-box;
  flex: 1;
}
.checkin_information_data_raduis {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.checkin_information_data_content2 {
  width: 100%;
  flex: 1;
}
.depa_name {
  font-size: 20px;
  color: #131523;
  font-weight: bold;
  margin: 20px 0 0 46px;
}
</style>

<template>
  <div v-if="isAll" class="checkin_information_data_statistics_all">
    <div class="checkin_information_data_statistics">
      <div class="checkin_information_data_statistics_sing"
          v-for="(item, index) in statistics"
          :key="index"
      >
        <div class="checkin_information_data_statistics_title">
          {{ item.label }}
        </div>
        <div class="checkin_information_data_statistics_people">
          {{ item.value }}
        </div>
      </div>
    </div>
    <div  class="checkin_information_data_content"  id="addressChart" ref="addressChart"></div>
  </div>
  <div class="checkin_information_data_raduis" v-else>
    <div class="depa_name">{{ queryForm.deptName }}</div>
    <div
        id="raidsChart" ref="raidsChart"
        class="checkin_information_data_content2"
    ></div>
  </div>
</template>


<script>
import * as echarts from "echarts";
import {BmsAttendanceRecordApi} from '@/api/server/bmsAttendanceRecord';

export default {
  components: {},
  data() {
    return {
      isAll: true,
      selectDepaName: "部门1",
      statistics: [
        { label: "应出勤天数：", value: 0,},
        { label: "实际出勤天数：",value: 0,},
        { label: "旷工天数：", value: 0,},
        { label: "迟到次数：", value: 0,},
        { label: "早退次数：", value: 0,},
        { label: "加班小时：", value: 0,},
        { label: "请假天数：", value: 0,}
      ],
      queryForm: {},
      deptEcharts: null,
      pieDeptEcharts: null,
      echartsInterval: null,
    };
  },
  created() {

  },
  mounted() {
      // this.initRadisEcharts();
      // this.initEcharts();
    this.echartsInterval = setInterval(() => {
      this.setData();
    },30000)
  },
  destroyed() {
    this.echartsInterval && clearInterval(this.echartsInterval);
    this.echartsInterval = null;
  },
  methods: {
    setData() {
      BmsAttendanceRecordApi.queryBmsAttendanceDashboardRespVOList(this.queryForm).then(response => {
        const {code,data} = response;
        this.statistics = [
          { label: "应出勤天数：", value: data?.map(d => d.totalExpectedAttendanceDay)?.reduce((prev, cur) => prev + cur, 0) || 0 },
          { label: "实际出勤天数：",value: data?.map(d => d.totalAttendanceDay)?.reduce((prev, cur) => prev + cur, 0) || 0 },
          { label: "旷工天数：", value: data?.map(d => d.totalAbsenceDay)?.reduce((prev, cur) => prev + cur, 0)?.toFixed(0) || 0 },
          { label: "迟到次数：", value: data?.map(d => d.totalLateCount)?.reduce((prev, cur) => prev + cur, 0) || 0 },
          { label: "早退次数：", value: data?.map(d => d.totalEarlyCount)?.reduce((prev, cur) => prev + cur, 0) || 0 },
          { label: "加班小时：", value: data?.map(d => d.totalOvertimeDuration)?.reduce((prev, cur) => prev + cur, 0)?.toFixed(1) || 0 },
          { label: "请假天数：", value: data?.map(d => d.totalLeaveDay)?.reduce((prev, cur) => prev + cur, 0)?.toFixed(0) || 0 }
        ]
        if(this.isAll && this.deptEcharts){
          let option = this.deptEcharts.getOption();
          option.xAxis[0].data = data?.map(d => d.name) || [];
          option.series[0].data = data?.map(d => d?.totalAttendanceDay || 0) || [];
          option.series[1].data = data?.map(d => d?.totalAbsenceDay || 0) || [];
          option.series[2].data = data?.map(d => d?.totalLateCount || 0) || [];
          option.series[3].data = data?.map(d => d?.totalEarlyCount || 0) || [];
          option.series[4].data = data?.map(d => d?.totalOvertimeDuration || 0) || [];
          option.series[5].data = data?.map(d => d?.totalLeaveDay || 0) || [];
          option.dataZoom[0].end = (10 / (data?.map(d => d.name)?.length || 1)) * 100;
          this.deptEcharts.setOption(option);
        }else if(!this.isAll && this.pieDeptEcharts){
          let option = this.pieDeptEcharts.getOption();
          option.series[0].data[0].value = data?.map(d => d.totalAbsenceDay)?.reduce((prev, cur) => prev + cur, 0) || 0;
          option.series[0].data[1].value = data?.map(d => d.totalLateCount)?.reduce((prev, cur) => prev + cur, 0) || 0;
          option.series[0].data[2].value = data?.map(d => d.totalEarlyCount)?.reduce((prev, cur) => prev + cur, 0) || 0;
          option.series[0].data[3].value = data?.map(d => d.totalOvertimeDuration)?.reduce((prev, cur) => prev + cur, 0) || 0;
          option.series[0].data[4].value = data?.map(d => d.totalLeaveDay)?.reduce((prev, cur) => prev + cur, 0) || 0;
          this.pieDeptEcharts.setOption(option);
        }
      })
    },
    init(query){
      this.isAll = !query.deptId;
      this.deptEcharts?.dispose();
      this.pieDeptEcharts?.dispose();
      this.deptEcharts = null;
      this.pieDeptEcharts = null;
      setTimeout(() => {
        this.queryForm = query;
        if(this.isAll){
          this.initEcharts();
        }else {
          this.initRadisEcharts();
        }
        this.setData();
        this.$forceUpdate();
      },50)
    },
    initEcharts() {

      const option = {
        // 图例
        legend: {
          left: 30, // 让图例靠右 可以是数值 也可以是"%"
          to: 10,
          icon: 'circle'
        },
        // 提示框
        tooltip: {
          trigger: 'axis', // 触发类型 axis-坐标轴触发(主要在柱状图，折线图等会使用类目轴的图表中使用)
          // 坐标轴指示器配置项
          axisPointer: {
            type: 'shadow'
          }
        },
        // 绘图网格
        grid: {
          left: '3%', // 离容器左侧的距离
          right: '4%', // 离容器右侧的距离
          bottom: '3%', // 离容器下侧的距离
          containLabel: true // grid 区域是否包含坐标轴的刻度标签
        },
        xAxis: {
          data: [],
          type: 'category', // 坐标轴类型为category-类目轴
          axisLabel: {
            //坐标轴刻度标签的相关设置
            show: true, //是否显示
            textStyle: {
              color: '#7E84A3',
              borderWidth: 0,
              fontSize: 14
            },
            interval: 0
          },
          axisTick: {
            show: false //是否显示
          }
        },
        yAxis: {
          type: 'value', // 坐标轴类型为数值轴
          minInterval: 1, // 最小间隔大小 因为此项目该数据不可能有小数 所以设置为1
          min: 0,
          max: (value) => {
            return value.max;
          },
          boundaryGap: [0, '10%']
        },
        series: [
          {
            name: '出勤',
            type: 'bar',
            barWidth: 16,
            itemStyle: {
              color: '#21D59B',
              borderRadius: [8, 8, 0, 0]
            },
            data: []
          },
          {
            name: '旷工',
            type: 'bar',
            barWidth: 16,
            itemStyle: {
              color: '#0062FF',
              borderRadius: [8, 8, 0, 0]
            },
            data: []
          },
          {
            name: '迟到',
            type: 'bar',
            barWidth: 16,
            itemStyle: {
              color: '#36C9C9',
              borderRadius: [8, 8, 0, 0]
            },
            data: []
          },
          {
            name: '早退',
            type: 'bar',
            barWidth: 16,
            itemStyle: {
              color: '#FBD437',
              borderRadius: [8, 8, 0, 0]
            },
            data: []
          },
          {
            name: '加班',
            type: 'bar',
            barWidth: 16,
            itemStyle: {
              color: '#F2637B',
              borderRadius: [8, 8, 0, 0]
            },
            data: []
          },
          {
            name: '请假',
            type: 'bar',
            barWidth: 16,
            itemStyle: {
              color: '#975FE5',
              borderRadius: [8, 8, 0, 0]
            },
            data: []
          }
        ],
        dataZoom: [
          {
            type: 'inside', //鼠标可拖动
            start: 0, //滚动条开始位置
            end: 70, //滚动条结束位置
            handleSize: 2
          }
        ]
      };
      this.deptEcharts = echarts.init(this.$refs?.addressChart);
      this.deptEcharts.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.deptEcharts.resize();
      });
    },
    initRadisEcharts() {
      const option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            padAngle: 5,
            itemStyle: {
              borderRadius: 10
            },
            label: {
              show: true,
              formatter: function (arg) {
                return arg.name + '-' + arg.value;
              }
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true
            },
            data: [
              {
                value: 0,
                name: '旷工(天)',
                itemStyle: {
                  color: '#0062FF'
                }
              },
              {
                value: 0,
                name: '迟到(次数)',
                itemStyle: {
                  color: '#36C9C9'
                }
              },
              {
                value: 0,
                name: '加班(小时)',
                itemStyle: {
                  color: '#F2637B'
                }
              },
              {
                value: 0,
                name: '早退(次数)',
                itemStyle: {
                  color: '#FBD437'
                }
              },
              {
                value: 0,
                name: '请假(天)',
                itemStyle: {
                  color: '#975FE5'
                }
              }
            ]
          }
        ]
      };
      this.pieDeptEcharts = echarts.init(this.$refs?.raidsChart);
      this.pieDeptEcharts.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.pieDeptEcharts.resize();
      });
    },
  },

};
</script>